

import { Flashcard, Subject, Difficulty, QuizResponse } from "../types";
import { api } from "./api";

// The Gemini API logic is now on the backend (server/controllers/quizController.ts).
// This service simply forwards the request.

export const generateQuiz = async (
  grade: string,
  state: string,
  subject: Subject,
  topic: string,
  difficulty: Difficulty,
  priorMastery: number = -1
): Promise<QuizResponse> => {
  try {
    const response = await api.post('/quiz/generate', {
      grade, state, subject, topic, difficulty, mastery: priorMastery
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    // Fallback or rethrow
    return { questions: [] };
  }
};

export const generateFlashcards = async (
  grade: string,
  state: string,
  topic: string
): Promise<Flashcard[]> => {
  try {
    const cards = await api.post('/quiz/flashcards', {
      grade, state, topic
    });
    return cards;
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};
